import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const DateSince = ({ date }) => {
  if (!date) {
    return '';
  }

  const t = {
    today_time: '[Today] HH:mm',
    yesterday_time: '[Yesterday] HH:mm',
  };

  const now = moment();

  const formatDate = moment(date + 'Z'); // Mayan could not store an utc date
  const today = moment();
  if (formatDate.isSame(today, 'day')) {
    return formatDate.format(t.today_time);
  }

  if (formatDate.isSame(today.subtract(1, 'days'), 'day')) {
    return formatDate.format(t.yesterday_time);
  }

  return (
    <span className="date-since" data-testid="date-since">{`${now.diff(
      formatDate,
      'days'
    )}d ago`}</span>
  );
};

DateSince.propTypes = {
  date: PropTypes.string.isRequired,
};

export default DateSince;
